// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2u5xv","errorLogs":"styles_errorLogs__1eIXs"};